
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/brand/[handle]",
      function () {
        return require("private-next-pages/collections/brand/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/brand/[handle]"])
      });
    }
  